module.exports = __webpack_public_path__ + "static/food-blog-tablet-plp-473eb644950314da671ed3cab67b6e02.png";